export const FOLLOW_AUTHOR_EXPERIMENT_ID = 'byline-follow-button';
